
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/algorithm-transparency",
      function () {
        return require("private-next-pages/newsroom/algorithm-transparency.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/algorithm-transparency"])
      });
    }
  